import React from 'react';
import OdezaAppStandalone from 'odeza-customer-chat-core/src/OdezaAppStandalone';
import {config} from './config';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {MESSAGE_STANDARD_INFO_WIDGET, QUEUE_NAME_RSFH_CUSTOMER_SERVICE} from "./constants";

import avatar from "./images/roper_icon.png";
import logo from "./images/roper_logo.png";

function App() {

    const customRoutes = [
        {route: '/', startQueueName: QUEUE_NAME_RSFH_CUSTOMER_SERVICE},
    ];

    const setLogosByQueue = (config, queueName) => {
        config.chatLogo = logo;
        config.avatarUrl = avatar;
    };

    const getStyleByQueue = (config, queueName) => {
        // return <style></style>
    }

    return (
        <Router>
            <Switch>
                {/* --- Custom routes --- */}
                {
                    customRoutes.map((record, key) => {
                        return <Route key={key} path={process.env.PUBLIC_URL + record.route}
                                      render={(props) => {
                                          config.startQueueName = record.startQueueName;
                                          const query = new URLSearchParams((props.location || {}).search);
                                          const data = query.get('data');
                                          const chatOpts = data ? JSON.parse(atob(data)) : {};
                                          if(chatOpts.isStandaloneWidget) {
                                              config.hooks.getSecondStartMessages = (props) => {
                                                  return [{title: MESSAGE_STANDARD_INFO_WIDGET}];
                                              }
                                          }
                                          setLogosByQueue(config, record.startQueueName);
                                          return <>
                                              {getStyleByQueue(config, record.startQueueName)}
                                              <base target="_target"/>
                                              <OdezaAppStandalone
                                                  {...props}
                                                  config={config}
                                                  startQueueName={record.startQueueName}
                                              />
                                          </>
                                      }}
                        />
                    })
                }
                {/*--- Main\Default route ---*/}
                {/*
				<Route path={process.env.PUBLIC_URL + "/:mrn?/:department?/:ref?/:username?"}
					   render={(props) => (
						   <OdezaAppStandalone
							   {...props}
							   config={config}
						   />
					   )}
				/>
				*/}
            </Switch>
        </Router>
    );
}

export default App;
